<div
  class="pagination__item rounded mt-2 cursor-pointer"
  matTooltip="{{ exercise.isHidden ? ('f.pagination.disabled' | translate) : '' }}"
  matTooltipClass="mat-tooltip"
  matTooltipPosition="below"
  (click)="clickOnVisibility(exercise)">
  <svg-icon *ngIf="exercise.isHidden" key="disable-circle" size="sm"></svg-icon>
  <svg-icon *ngIf="!exercise.isHidden" key="icon-eye-nc" size="xl"></svg-icon>
</div>
